import React from 'react';
import {
  ReactCompareSlider,
  ReactCompareSliderImage,
} from 'react-compare-slider';

const ImageCompareSlider = ({ img1, img2 }: { img1: string; img2: string }) => {
  return (
    <div className="py-3">
      <ReactCompareSlider
        className="rounded-[10px]"
        itemOne={<ReactCompareSliderImage src={img1} alt="Image one" />}
        itemTwo={<ReactCompareSliderImage src={img2} alt="Image two" />}
      />
    </div>
  );
};

export default ImageCompareSlider;
